import * as React from "react";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { useLocation } from "react-router-dom";
import Loader from "components/Loader";
import Pager from "components/Pager";
import PageState from "components/PageState";
import { useContext } from "context";
import { LeaderboardEntryType } from "context/state";
import stringIsInteger from "helpers/stringIsInteger";
import download from "./download";
import LeaderRow from "./LeaderRow";
import Search from "./Search";

const pageSize = 100;

export default function Home() {
  const {
    leaders: {
      data = { timestamp: undefined, leaderboard: [] },
      error,
      loading,
    },
  } = useContext();
  const { search } = useLocation();

  const query = new URLSearchParams(search);
  const urlPage = query.get("page") ? String(query.get("page")) : "";
  const address = query.get("address") ? String(query.get("address")) : "";
  const showTeam = query.get("team") ? String(query.get("team")) : "";
  const exportData = query.get("export") ? String(query.get("export")) : "";
  const page = stringIsInteger(urlPage) ? parseInt(urlPage) : 1;

  const allData = Boolean(showTeam)
    ? data.leaderboard
    : data.leaderboard.filter(({ teamMember: isTeamMember }) => {
        const showAll = showTeam ? true : !isTeamMember;
        return showAll;
      });

  const [results, setResults] = React.useState<LeaderboardEntryType[]>([]);
  const [exportRequest, setExportRequest] = React.useState<boolean>();

  React.useEffect(() => {
    if (!loading) {
      const newOffset = Math.ceil(page * pageSize);
      const start = (page - 1) * pageSize;
      const end = newOffset || pageSize;
      const newResults = [...allData].slice(start, end);

      if (address) {
        const filteredResults = allData.filter((el) =>
          el.address.includes(address),
        );
        setResults(filteredResults);
      } else {
        setResults(newResults);
      }

      if (exportData) {
        setExportRequest(true);
      }
    }
  }, [search, data, loading]);

  const addresses = allData.map((el) => el.address);

  React.useEffect(() => {
    if (exportRequest && allData.length > 0 && data.timestamp) {
      setExportRequest(false);
      download(
        allData,
        moment(parseInt(data.timestamp)).format("MM-DD-YYYY HH:mm"),
      );
    }
  }, [exportRequest, allData, data.timestamp]);

  return (
    <div>
      <div className="row">
        <div className="col pt-2">
          <h1 className="text-center title mb-0">Leaderboard</h1>
          {data.timestamp && (
            <div className="text-center d-flex flex-column">
              <small className="text-secondary">
                Last updated:{" "}
                {moment(parseInt(data.timestamp)).format(
                  "MMMM Do YYYY, h:mm A",
                )}
              </small>
              <small className="text-secondary">
                Final rankings for Battle of Yields
              </small>
            </div>
          )}
        </div>
      </div>
      <div className="row mt-4">
        <div className="col mb-5">
          <div className="d-flex flex-row justify-content-center">
            <Search urlAddress={address} />
          </div>
        </div>
      </div>
      {error ? (
        <PageState
          icon={faTimes}
          iconBgClass="text-white bg-danger"
          iconClass=""
          iconSize="3x"
          title="Request failed."
          description={<></>}
        />
      ) : (
        <>
          {loading ? (
            <Loader />
          ) : (
            <div className="row">
              <div className="col table-container">
                <table className="table table-dark leaderboard">
                  <thead>
                    <tr>
                      <th className="text-right">Rank</th>
                      <th>Address</th>
                      <th className="text-right">Total Value</th>

                      <th className="text-right">MEX Farm</th>
                      <th className="text-right">EGLD-MEX Farm</th>
                      <th className="text-right">EGLD-BUSD Farm</th>

                      <th className="text-right">EGLD</th>
                      <th className="text-right">MEX</th>
                      <th className="text-right">LKMEX</th>

                      <th className="text-right">BUSD</th>

                      <th className="text-right">EGLD-BUSD LP</th>
                      <th className="text-right">EGLD-MEX LP</th>

                      <th className="text-right">Nonce</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="message d-none">
                      <td className="text-center" colSpan={8}>
                        This is custom message
                      </td>
                    </tr>
                    {results.map((row, i) => (
                      <LeaderRow
                        {...row}
                        key={i}
                        rank={addresses.indexOf(row.address) + 1}
                      />
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </>
      )}

      {allData.length > 0 && (
        <div className="card-footer px-sm-4">
          <Pager
            itemsPerPage={pageSize}
            total={allData.length || 0}
            page={String(page)}
            show={allData.length > 0}
          />
        </div>
      )}
    </div>
  );
}
